module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EmptyCart":{"button":{"ariaLabel":"Odstranit všechny položky z košíku","text":"Vysypat košík"}}},"de":{"EmptyCart":{"button":{"ariaLabel":"Alle Artikel aus dem Warenkorb entfernen","text":"Leeren Sie den Warenkorb aus"}}},"sk":{"EmptyCart":{"button":{"ariaLabel":"Odstrániť všetky položky z košíka","text":"Vysypať košík"}}}}')
  delete Component.options._Ctor
}
